import { buildApiUrl } from '../config';
import useAPI from '../../hooks/useAPI';
import { useState } from 'react';
import { z } from 'zod';

// Import existing types to use in function signatures
import { AddContactsToProjectRequest } from '../../types/backendRequests/AddContactsToProjectRequest';
import { AddContactsToProjectRequestSchema } from '../schemas/projectContactSchemas';

/**
 * Hook for adding contacts to project with built-in state management
 * Includes Zod validation for type safety
 */
export const useAddContactsToProject = () => {
  const { callAPI } = useAPI({ method: 'PUT' });

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  /**
   * Add contacts to project
   * @param requestData - The request data
   * @returns Promise with boolean indicating success
   */
  const action = async (requestData: AddContactsToProjectRequest): Promise<boolean> => {
    setIsLoading(true);
    setError(null);
    try {
      // Validate the request data
      const validatedRequest = /* AddContactsToProjectRequestSchema.parse( */ requestData; /* ) */

      await callAPI(buildApiUrl('project/contacts'), validatedRequest);
      return true;
    } catch (error) {
      console.error('Error in useAddContactsToProject:', error);
      setError(error);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    action,
  };
};
